import {data} from './configurator-data.js';
import {fetchProductData, productData} from './product-data.js'
import {displayProduct, clearSection, displayMessage} from "./configurator-functions.js"

fetchProductData(productData);

document.addEventListener('DOMContentLoaded', function () {
  const brandSelect = document.getElementById('brand-select');
  const modelSelect = document.getElementById('model-select');
  const yearSelect = document.getElementById('year-select');

  brandSelect.addEventListener('change', function () {
      const selectedBrand = this.value;
      modelSelect.innerHTML = '<option value="" disabled selected>Model</option>';
      yearSelect.innerHTML = '<option value="" disabled selected>Year</option>';
      clearSection();

      if (selectedBrand && data[selectedBrand]) {
          const models = Object.keys(data[selectedBrand]);
          models.forEach(function (model) {
              const option = document.createElement('option');
              option.value = model;
              option.textContent = model;
              modelSelect.appendChild(option);
          });
      }
  });

  modelSelect.addEventListener('change', function () {
      const selectedBrand = brandSelect.value;
      const selectedModel = this.value;
      yearSelect.innerHTML = '<option value="" disabled selected>Year</option>';
      clearSection();

      if (selectedBrand && selectedModel && data[selectedBrand][selectedModel]) {
          const years = Object.keys(data[selectedBrand][selectedModel]);
          years.forEach(function (year) {
              const option = document.createElement('option');
              option.value = year;
              option.textContent = year;
              yearSelect.appendChild(option);
          });
      }
  });


  yearSelect.addEventListener('change', function () {
      const selectedBrand = brandSelect.value;
      const selectedModel = modelSelect.value;
      const selectedYear = this.value;
      clearSection();

      if (selectedBrand && selectedModel && selectedYear && data[selectedBrand][selectedModel][selectedYear]) {
        const ledLightsData = data[selectedBrand][selectedModel][selectedYear];
        let noneMatchingProduct = 0;
        let worklightProduct = 0;
        let headlightProduct = 0;
        let workLightingAccessoryProduct = 0;
        let headLightingAccessoryProduct = 0;
        let lightingPackageProduct = 0;
      
        // Iterate over the LED lights and create HTML elements to display them
        for (const lightType of Object.keys(ledLightsData)) {
          if (!productData.hasOwnProperty(lightType)) {
            console.log(`SKU not found in productData: ${lightType}`);
            continue; // skip this iteration
          }
          const { url, imageUrl, productTitle, price, centPrice} = productData[lightType];
          let productType = productData[lightType].type;
          let containerId;
          let headerText;
          let productAmount;
          
          switch (productType) {
            case 'LED Work Light':
              worklightProduct++;
              break;
            case 'LED Headlight':
              headlightProduct++;
              containerId = 'headlights-section';
              headerText = 'Headlights';
              productAmount = headlightProduct;
              break;
            case 'Headlight Lighting Accessory':
              headLightingAccessoryProduct++;
              containerId = 'accessories-section';
              headerText= 'Lighting Accessories';
              productAmount = headLightingAccessoryProduct;
              break;
            case 'Worklight Lighting Accessory':
              workLightingAccessoryProduct++
              break;
            case 'LED Worklight Package':
              lightingPackageProduct++;
              break;
            case 'LED Light Package':
            case 'LED Headlight Package':
              lightingPackageProduct++;
              containerId = 'lighting-package-section';
              headerText = 'Lighting Packages';
              productAmount = lightingPackageProduct
              break;
            default:
              noneMatchingProduct++;
              console.log(productType);
              continue;
          };
          if (containerId=== 'accessories-section' || containerId=== 'headlights-section' || containerId=== 'lighting-package-section'){
            displayProduct(containerId, headerText, url, imageUrl, productTitle, price, productAmount, centPrice);
          };
        };
        if (noneMatchingProduct>0) {
          console.log(`There is ${noneMatchingProduct} none matching products`)
        };
        if (headlightProduct === 0 && headLightingAccessoryProduct === 0 && lightingPackageProduct === 0){
          displayMessage();
        };
      };
  });
});